export default __webpack_public_path__ + "static/media/logo_suma+.1b0e7c53.svg";